<template>
<CContainer>
    <NegativeStoresListTable :list="negativeList" class="mt-2" />
</CContainer>
</template>

<script>
import { walletService } from '@/services/api'
import { NegativeStoresListTable } from './partials'
import { groupByArrayOfObject } from '@/common/arrays'

export default {
    name: 'NegativeStoresList',

    components: {
        NegativeStoresListTable,
    },

    data() {
        return {
            negativeList: []
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.negativeStoresList({
                no_paginate: true
            })
        })
    },

    methods: {
        negativeStoresList(params) {
            walletService.negativeStoresList(params).then(response => {
                const result = response.data
                this.negativeList = groupByArrayOfObject(result.data, 'id')
            })
        }
    }
}
</script>